import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/client-card/search';

const PageClientCard: React.FC = (props) => {
  const ClientCardPage = Loadable({
    loader: () => import('./page'),
    loading: LoadableLoading,
  });

  return <ClientCardPage {...props} />;
};

export default PageClientCard;
